export default __webpack_public_path__ + "static/media/advcol1.72adf13f.svg";